import React from "react";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
var BrokerageDiscountTable = function (props) {
    var _a, _b, _c, _d;
    var brokerageColumn = [
        {
            columnName: "Segment",
            key: "subcategoryName",
        },
        {
            columnName: "Current/Actual",
            key: "actual",
        },
        {
            columnName: "Current/Actual Min",
            key: "actualMin",
        },
        {
            columnName: "Post Consumption",
            key: "postConsumption",
        },
        {
            columnName: "Post Consumption Min",
            key: "postConsumptionMin",
        },
        {
            columnName: "Post Expiry",
            key: "postExpire",
        },
        {
            columnName: "Post Expiry Min",
            key: "postExpireMin",
        },
    ];
    var discountColumn = [
        {
            columnName: "Name",
            key: "subcategoryName",
        },
        {
            columnName: "Value",
            key: "value",
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "padding-30" },
            React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 mb-2 pb-1" }, "Brokerage"),
            React.createElement(GenericTable, { parentClassName: "common-modal-table", columns: brokerageColumn, data: (_a = props === null || props === void 0 ? void 0 : props.planData) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.categoryName) === "BROKERAGE"; }) })),
        React.createElement("div", { className: "padding-30 pt-0" },
            React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 mb-2 pb-1" }, "Discount"),
            React.createElement(GenericTable, { parentClassName: "common-modal-table", columns: discountColumn, data: (_b = props === null || props === void 0 ? void 0 : props.planData) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.categoryName) === "DISCOUNT"; }) })),
        ((_c = props === null || props === void 0 ? void 0 : props.planData) === null || _c === void 0 ? void 0 : _c.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.categoryName) === "AMC"; }).length) > 0 && (React.createElement("div", { className: "padding-30 pt-0" },
            React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 mb-2 pb-1" }, "AMC"),
            React.createElement(GenericTable, { parentClassName: "common-modal-table", columns: discountColumn, data: (_d = props === null || props === void 0 ? void 0 : props.planData) === null || _d === void 0 ? void 0 : _d.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.categoryName) === "AMC"; }) })))));
};
export default BrokerageDiscountTable;
